import { useMutation, useQueryClient } from 'react-query'
import { postJSON } from 'common/services/api'
import { showToast } from 'common/utils'
import {
  EMAIL_SEND_PUBLISHED_ROTA_URL,
  EMAIL_SEND_PUBLISHED_ROTA_QUERY_KEY,
} from './queryConstants'

type UseRotaPublishedSendEmailReturn = {
  sendEmail: (args?: SendEmailArgs) => Promise<unknown>
  isLoading: boolean
}

type SendEmailArgs = {
  carerId: string
  intervalType: 'daily' | 'weekly'
  rotaDate: string
}

const useRotaPublishedSendEmail = (): UseRotaPublishedSendEmailReturn => {

  const sendEmailFunction = async (args?: SendEmailArgs): Promise<unknown> => {
    return postJSON({
      url: EMAIL_SEND_PUBLISHED_ROTA_URL,
      method: 'POST',
      isRota: true,
      json: args,
    })
  }

  const { mutateAsync: sendEmailMutation, isLoading } = useMutation<
    unknown,
    unknown,
    SendEmailArgs | undefined
  >([EMAIL_SEND_PUBLISHED_ROTA_QUERY_KEY], sendEmailFunction, {
    onSuccess: () => {
		showToast({
			title: 'Published rota email sent successfully',
			type: 'success',
		  })
    },
  })

  const sendEmail = async (args?: SendEmailArgs) => {
    try {
      const result = await sendEmailMutation(args)
      return result
    } catch (err) {
      return err
    }
  }

  return {
    sendEmail,
    isLoading,
  }
}

export default useRotaPublishedSendEmail
